module.exports = __webpack_public_path__ + "files/9de0cab3839a62c2dd9ed9cfd174a6a1.png";


//////////////////
// WEBPACK FOOTER
// ./images/browsers/chrome.png
// module id = 798
// module chunks = 0